import React from 'react';
import { X, ArrowLeft, Clock } from 'lucide-react';
import '../styles/booking.css';
import '../styles/doctor-booking-flow.css';

const ServiceSelectionModal = React.memo(({ services, onServiceSelect, onBack, onClose }) => {
  React.useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };
    document.addEventListener('keydown', handleEscape);
    return () => document.removeEventListener('keydown', handleEscape);
  }, [onClose]);

  return (
    <div 
      className="modal-overlay" 
      onClick={onClose}
      role="dialog"
      aria-modal="true"
      aria-labelledby="service-selection-title"
    >
      <div className="modal-content service-selection-modal" onClick={(e) => e.stopPropagation()}>
        <button 
          className="modal-back" 
          onClick={onBack} 
          type="button"
          aria-label="Повернутися до інформації про лікаря"
        >
          <ArrowLeft size={24} aria-hidden="true" />
        </button>
        
        <button 
          className="modal-close" 
          onClick={onClose} 
          type="button"
          aria-label="Закрити вікно"
        >
          <X size={24} aria-hidden="true" />
        </button>

        <h2 id="service-selection-title" className="modal-title">Оберіть послугу</h2>
        <p className="modal-subtitle">Виберіть послугу для запису</p>

        <div className="services-grid" role="list">
          {services.map((service) => (
            <div 
              key={service.id} 
              className="service-card-modal"
              onClick={() => onServiceSelect(service)}
              onKeyPress={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  onServiceSelect(service);
                }
              }}
              role="button"
              tabIndex={0}
              aria-label={`Вибрати послугу ${service.title}, ${service.price}, тривалість ${service.duration}`}
            >
              <div className="service-image-wrapper-modal">
                <img 
                  src={service.image} 
                  alt={service.title}
                  loading="lazy"
                  decoding="async"
                />
              </div>
              <div className="service-content-modal">
                <h3>{service.title}</h3>
                <p>{service.description}</p>
                <div className="service-info-modal">
                  <span className="service-duration-modal">
                    <Clock size={16} />
                    {service.duration}
                  </span>
                  <span className="service-price-modal">{service.price}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
});

ServiceSelectionModal.displayName = 'ServiceSelectionModal';

export default ServiceSelectionModal;
